__webpack_require__.p = "/wp-content/themes/bouygues-le-mag-2025/assets/";